import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

const logos = [
  // "/img/logo/oti.png",
  "/img/logo/bismak.png",
  "/img/logo/sirab.png",
  "/img/logo/tubis.png",
  // "/img/logo/iva.png",
  "/img/logo/ilmak.png",
  "/img/logo/badamli.png",
  "/img/logo/unmak.png",
  "/img/logo/ayna.jpg",
  "/img/logo/powdermak.png",

];

export const Features = () => {
  return (
    <div style={{ backgroundColor: "#f9f9f9" }}>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '30px 0 10px 0', backgroundColor: 'rgb(63, 78, 79)' }}>
        <h2
          style={{
            fontSize: "2.8rem",
            fontWeight: "700",
            marginBottom: "30px",
            color: "#ddd",
            position: "relative",
            textAlign: "center",
          }}
        >
          Our Brands
          <span
            style={{
              position: "absolute",
              width: "50%",
              height: "4px",
              backgroundColor: "#C38745",
              left: "25%",
              bottom: -10,
            }}
          ></span>
        </h2>
      </div>
      <div style={{ padding: '40px 0', height: 'fit-content' }}>
        <Swiper
          modules={[Autoplay]}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={3000}
          loop={true}
          spaceBetween={20}
          slidesPerView={6}
          breakpoints={{
            0: { slidesPerView: 3 },
            480: { slidesPerView: 4 },
            768: { slidesPerView: 5 },
            1024: { slidesPerView: 6 },
          }}
          style={{ padding: "0 40px" }}
        >
          {logos.map((src, index) => (
            <SwiperSlide key={index}>
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 80,
                padding: 10
              }}>
                <img
                  src={src}
                  alt={`Logo ${index}`}
                  loading="lazy"
                  style={{
                    maxHeight: 50,
                    maxWidth: "100%",
                    objectFit: "contain",
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
